import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Get Bank Names List API Call
 * @returns {Promise<Object>} - Response data containing list of bank names
 */
export const getBankNamesList = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.BANK_NAMES_LIST);
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 